import {removeLeadContact} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../../../lead-keys";

export function removeLeadContactMutationOptions(leadId: string) {
  return mutationOptions({
    mutationKey: leadMutationKeys.removeLeadContact,
    mutationFn: (contactId: number) => removeLeadContact(leadId, contactId),
    onSuccess: async (_result, _contactId, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.detail(leadId)});
    },
  });
}
